import {Spinner} from "../libs/spinner";
import simpleModal from "../libs/simpleModal";
import showConfirm from "../libs/showConfirm";
import createDynamicModal from "../libs/dynamicModal";
import docready from "../libs/docready";

const exportSubscribers = function () {
    $("<form />", {
        'action': '/admin/export/subscribers',
        'target': self.target,
        'method': 'post',
        css: {'display': 'none'}
    })
        .append($('<input>', {type: 'hidden', 'name': 'gid', 'value': gid}))
        .append($('<input>', {type: 'hidden', 'name': 'cid', 'value': cid}))
        .append($('<input>', {type: 'hidden', 'name': 'lang', 'value': document.documentElement.lang}))
        .append($('<input>', {type: 'hidden', 'name': 'active_filter', 'value': 1}))
        .append($('<input>', {
            type: 'hidden',
            'name': yii.getCsrfParam() || '_csrf',
            'value': yii.getCsrfToken() || null
        }))
        .appendTo('body')
        .submit()
        .remove()
}

let filter = {};
const direction = $('html').attr('dir');
const closeFilterModal = function (e) {
    if ($(e.target).closest('.filter-modal').length === 0) {
        $('.filter-modal').remove();
    }
};
$(document).on('click', '.window', closeFilterModal);
const fixFilterModal = function (modalId) {
    const modal = $('#' + modalId);
    const filterModal = modal.find('.filter-modal');
    if (filterModal && filterModal.length) {
        const column = parseInt(filterModal.data('column'), 10);
        const header = modal.find(`.subscribers-table thead tr th:nth-child(${column + 1})`);
        filterModal.css({
            'top': header.outerHeight() + modal.find('.list-actions').outerHeight() + 'px',
        });
        if (direction === 'rtl') {
            filterModal.css({'right': (modal.find('.subscribers-table').outerWidth() - header.position().left - header.outerWidth() + modal.find('.table-responsive').scrollLeft()) + 'px'});
        } else {
            filterModal.css({'left': (header.position().left - modal.find('.table-responsive').scrollLeft()) + 'px'});
        }
    }
}

const initFilter = function (modalId) {
    const modal = $('#' + modalId);
    const variants = {};
    modal.find('.subscribers-table thead tr th').each(function (i) {
        if ($(this).data('filter') === true && $(this).data('values')) {
            variants[i] = $(this).data('values').split(',');
        }
        ;
    });
    Object.keys(variants).map(Number).forEach(i => {
        const str = `.subscribers-table thead tr th:nth-child(${i + 1})`;
        const header = modal.find(str);
        let dropdown = `<a href="#" class="subscribers-filter-btn" data-column="${i}" title="Filter values"><svg class="svg-sprite svg-sprite-main" viewBox="0 0 10 11"><use xlink:href="#icon-filter"></use></svg></a>`;
        header.prepend(dropdown);
    });
    modal.find('.subscribers-table a.subscribers-filter-btn').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        modal.find('.filter-modal').remove();
        const column = $(this).data('column');
        const header = $(this).parent();
        let dropdown = `<ul class="filter-modal" data-column="${column}">`;
        header.data('values').split(',').forEach(z => {
            let checked = false;
            if (filter[column] && filter[column].includes(z)) {
                const index = filter[column].indexOf(z);
                if (index > -1) {
                    checked = true;
                }
            }
            dropdown += `<li><label><input type="checkbox" name="subscribersFilter[]" data-column="${column}" value="${z}" ${checked ? 'checked' : ''} />${z}</label></li>`;
        });
        dropdown += '</ul>';
        modal.find('.window-body').prepend(dropdown);
        fixFilterModal(modalId);
        modal.find('.filter-modal input[type="checkbox"]').on('click', function (e) {
            const column = $(this).data("column");
            const value = $(this).val();
            if (filter[column] && filter[column].includes(value)) {
                const index = filter[column].indexOf(value);
                if (index > -1) {
                    filter[column].splice(index, 1);
                }
            } else {
                if (!filter[column]) filter[column] = [];
                filter[column].push(value);
            }
            applyFilter(modalId);
        });
        return false;
    });
    $('.table-responsive').scroll(function () {
        fixFilterModal(modalId);
    });
}

const applyFilter = function (modalId) {
    const modal = $('#' + modalId);
    modal.find('.subscribers-table thead tr th').removeClass('has-checked-filter');
    modal.find('.subscribers-table tbody tr').removeClass('hidden');
    if (Object.keys(filter).length) {
        Object.keys(filter).map(Number).forEach(i => {
            if (filter[i] && filter[i].length) {
                modal.find(`.subscribers-table thead tr th:nth-child(${i + 1})`).each(function () {
                    $(this).addClass('has-checked-filter');
                });
                modal.find(`.subscribers-table tbody tr td:nth-child(${i + 1})`).each(function () {
                    const cell = $(this);
                    const row = cell.parent();
                    const values = cell.find(`span.value`).text().split(',');
                    if (!row.hasClass('hidden') && values.length > 0 && values[0] !== '') {
                        const findValues = values.some((value) => {
                            return filter[i].includes(value);
                        });
                        if (!findValues) {
                            row.addClass('hidden');
                        }
                    } else {
                        row.addClass('hidden');
                    }
                });
            }
        });
    }
    fixFilterModal(modalId);
}
const loadContent = async function (container, requestArgs) {
    return new Promise((resolve, reject) => {
        const args = structuredClone(requestArgs)
        const getItems = async function (page) {
            args.data.page = page
            const content = await $.get(args)
            if (content.items && content.items.length > 0) {
                content.items.forEach(item => {
                    const $item = $(item)
                    $item.appendTo(container)
                    docready($item)
                })
                setTimeout(() => {
                    getItems(page + 1)
                })
            } else {
                resolve()
            }
        }
        setTimeout(() => {
            getItems(1)
        })
    })
}

const regenerateRow = async function($caller) {
    const content = await $.get({url: '/site/subscriptions/admin-view-rows', data: {cid, gid, id: $caller.data('id')}})
    if (content.success && content.items && content.items.length > 0) {
        const $item = $(content.items[0])
        $caller.replaceWith($item)
        docready($item)
    }
}

const deleteRow = async function($caller) {
    $caller.closest('tr').remove()
    await recalculateFooter()
}

const loadAdminMemberList = async function (modalId) {
    const modal = $('#' + modalId);
    const spinner = new Spinner('#' + modalId + ' .window-body')
    spinner.show()
    let content = await $.get({
        url: '/site/subscriptions/admin-view-modal',
        data: {
            cid,
            gid,
        },
    })
    await modal.find('.window-head h2').html(content.render.head);
    await modal.find('.window-body').html(content.render.body);
    spinner.remove()
    const headSpinner = new Spinner('#' + modalId + ' .window-head')
    headSpinner.show('Loading')

    loadContent(modal.find('.window-body tbody.ajax-loaded'), {url: '/site/subscriptions/admin-view-rows', data: {cid, gid}})
        .then(recalculateFooter)
        .then(() => {
            headSpinner.remove()
            $('[data-toggle="tooltip"]').tooltip();
            modal.find('[data-tooltip]').data('tooltip-mobile-callback', $em => {
                const oldHtml = modal.children()
                oldHtml.detach()
                modal.html(`
                <svg viewBox="0 0 27 27" class="svg-sprite svg-sprite-main window-close" aria-label="Close" data-action="close"><title>Close</title><use xlink:href="#icon-close"></use></svg>
                <div class="window-body text">${$em.data('tooltip')}</div>
                `)
                modal.find('[data-action=close]').one('click', () => {
                    modal.html('')
                    oldHtml.appendTo(modal)
                })

            })
        })

    modal.find('.export_btn').click(() => {
        exportSubscribers();
        return false;
    });
    modal.find('.reset_filter_btn').on('click', e => {
        e.preventDefault();
        e.stopPropagation();
        filter = {};
        applyFilter(modalId);
        return false;
    });
    modal.find('.window-body :visible:focusable:first').focus()
    initFilter(modalId);
}

async function recalculateFooter()
{
    const table = $('#SubscribersListModal .subscribers-table')
    const summs = []
    const heads = table.find('thead th')
    heads.filter('[data-has-summ]').each(function() {
        summs.push({ column: heads.index(this), count: 0})
    })
    table.find('tbody tr').each(function() {
        const row = $(this).find('td')
        summs.forEach((item) => {
            item.count += parseFloat(row.eq(item.column).find('.value').text() || 0)
        })
    })
    const footer = table.find('tfoot tr td')
    summs.forEach((item) => {
        footer.eq(item.column - 2).text(item.count)
    })
}

window.showSubscribersListModal = async function () {
    try {
        const modal = new simpleModal({
            id: 'SubscribersListModal',
            content: '',
        })
        modal.show()
        await loadAdminMemberList(modal.id);
    } catch (e) {
        console.log(e)
    }
}

window.admin_unsubscribe_member = async function (caller) {
    const modalId = 'SubscribersListModal';
    const spinner = new Spinner('#' + modalId + ' .window-body')
    try {
        let confirmed
        if ($(caller).data('uid') === (window.user.id || 0) && $('#confirm-unsubscribe').length > 0 ) {
            confirmed = await showConfirm('#confirm-unsubscribe');
        } else {
            // set custom text
            $('#confirm-admin-unsubscribe .modal-body').html('Do you wish to unsubscribe ' + $(caller).data('uname') + ' from the activity?');
            confirmed = await showConfirm('#confirm-admin-unsubscribe');
        }
        if (confirmed) {
            spinner.show()
            let data = await $.ajax({
                url: '/site/groups/admin-un-subscribe-user',
                type: 'POST',
                data: {
                    cid: cid,
                    id: $(caller).data('id')
                }
            })
            spinner.remove();
            if (data.success) {
                await openAlert(data.message, 'success', 2000);
                await deleteRow($(caller));
            } else {
                window.openAlert(data.message, 'error');
            }
        }
    } catch (e) {
        spinner.remove();
        console.log(e);
        window.openAlert(getCommonError(), 'error');
    }
};

window.changeActualArrival = async function (_this) {
    let data = await $.ajax({
        url: '/site/groups/change-actual-arrival',
        type: 'POST',
        data: {
            cid: cid,
            id: $(_this).data('id'),
            value: $(_this).is(':checked')
        }
    });
    if (data.success) {
        window.openAlert(data.message, 'success', 2000);
    } else {
        window.openAlert(data.message, 'error', 2000);
    }
};

let searchCallId = null
let oldFilter = ''
$(document).on('keyup', '#SubscribersListModal .search input', function (e) {
    const filter = $(this).val();
    const modalId = 'SubscribersListModal';
    if (filter === oldFilter) {
        return
    }
    oldFilter = filter
    if (searchCallId) {
        clearTimeout(searchCallId)
        searchCallId = null
    }
    searchCallId = setTimeout(async () => {
        const spinner = new Spinner('#SubscribersListModal .window-body');
        spinner.show()
        const container = $('#' + modalId).find('.window-body tbody.ajax-loaded')
        container.html('')
        loadContent(container, {
            url: '/site/subscriptions/admin-view-rows',
            data: {cid, gid, filter}
        })
            .then(recalculateFooter)
            .then(() => {
                spinner.remove()
                $('[data-toggle="tooltip"]').tooltip();
            })

        initFilter(modalId);
    }, 1000)
})

window.editSubscriptionOption = async function (caller) {
    spinner.show();
    const $button = $(caller)
    const $row = $button.closest(('tr'))
    const type = $button.data('type')
    const field = $button.data('field')
    const key = $button.data('option')
    const ugId = $row.data('id')
    const userId = $row.data('uid')
    try {
        const res = await $.get({
            url: '/site/groups/edit-subscription-by-option',
            data: {
                field,
                ugId,
            },
        });
        spinner.remove();
        if (res.body && res.title && res.buttons) {
            const modal = await createDynamicModal(
                'EditSubscriptionOption',
                '#bootstrapModalsContainer',
                'md',
                res.title,
                res.body,
                res.buttons,
                {
                    modal: {
                        class: 'edit-subscription-detail-modal',
                    },
                }
            );
            $(modal).find('.btn-send').on('click', async function (e) {
                const place = $(this).closest('.edit-subscription-detail-modal');
                const container = $(this).closest('.edit-subscription-detail-modal');
                const form = container.find('form')
                const data = new FormData(form[0]);
                spinner.show();
                const response = await $.ajax({
                    url: form.attr('action'),
                    type: 'POST',
                    data,
                    processData: false,
                    contentType: false,
                });
                spinner.remove();
                if (response.success && response.message) {
                    openAlert(response.message, 'success');
                    $(modal).hide();
                    $(modal).remove();
                    const modalId = 'SubscribersListModal';
                    regenerateRow($row).then(recalculateFooter)
                } else if (response.message) {
                    openAlert(response.message, 'error');
                }
            });
            docready($(modal).find('.modal-body'))
        }
    } catch (e) {
        console.log(e);
        spinner.remove();
        window.openAlert(getCommonError(), 'error');
    }
}
